import React from 'react';
import Tabulation from '@wap/components/Tabulation';
import Keyboard from '@wap/components/Keyboard';
import * as utils from '../utils';

const odList = ['dataOdCytdnder', 'dataOdAxial'];
const osList = ['dataOsCytdnder', 'dataOsAxial'];
// 主觉验光 电脑验光
const validatorList = [
  odList,
  osList,
];
export default class ExamKeyBoard extends React.Component {
  constructor(props) {
    super(props);
    const {data = {}} = this.props;
    this.state = {
      data,
      eyeType: 'OD',
    };
  }
  componentDidMount() {
    // 处理数据回显的问题
    this.handleData();
  }

  /**
   * 处理一个指标key对应多个输入框的值回显
   */
  handleData = () => {
    const {config = {}, data = {}} = this.props;
    // 检查项的值
    const {examContent = {}} = data;
    const result = {};
    // 检查项的指标的key
    const {examIndiList = {}} = config; // 获取对应眼别的检查项的指标列表
    const {odList = [], osList = []} = examIndiList;
    // 找到所有的检查项的列表
    const allExamList = [...odList, ...osList];
    Object.entries(examContent).forEach(([key, value]) => {
      // 查看当前的检查项是否存在
      const currentExamKey =
        allExamList.find((exam) => exam?.option?.key === key) || {};
      // 查看是否存在一个指标key分很多个输入框
      // 即将一个指标项拆分成多个指标项
      const {account, option = {}} = currentExamKey;
      // 小数点的间隔距离
      const {suffixStep} = option;
      if (account) {
        // 取出数值型数据
        const num = value.replace(/[^0-9]/gi, '');
        const numList = num.split('');
        const valueList = value.split('') || [];
        //  查看存在小数点的位置
        const pointIndex = valueList.findIndex((item) => item === '.');
        // 当有小数点存在的时候，且值的小数点位置小于配置中小数点的间隔
        if (pointIndex > -1 && pointIndex < suffixStep) {
          // 前增补空
          valueList.splice(0, 0, '');
          const newPointIndex = valueList.findIndex((item) => item === '.');
          // 删除小数点
          newPointIndex > -1 && valueList.splice(newPointIndex, 1);
        } else {
          pointIndex > -1 && valueList.splice(pointIndex, 1);
        }
        // (new Array(account).fill('') || []).forEach((item, index_) => {
        valueList.forEach((item, index_) => {
          // examContent[`${key}@${index_ + 1}`] = numList[index_];
          examContent[`${key}@${index_ + 1}`] = item;
        });
        examContent[key] = '';
      }
    });
    this.setState({data: {...data, examContent: {...examContent}}});
  };

  tabRef = React.createRef();

  /**
   * 处理好的数据成传给保存提交
   * @returns [[-p]]
   */
  handleResult = () => {
    const {data} = this.state;
    const {examContent = {}} = data;
    // 是否存在一个指标拆分成多个指标项的时候
    const isExit = Object.entries(examContent).some(([key]) => /@/.test(key));
    // 判断是否需要校验
    const ifValidate = validatorList.some((list) => {
      return list.some((key) => examContent[key]);
    });
    //柱镜和轴向同时有值或为空
    if (ifValidate) {
      // const arr = validatorList.flat();
      // const isEmpty = arr.some((key) => !examContent[key]);
      // if (isEmpty) return {error: '柱镜轴向不能为空'};

      const isHaveOd = odList.some((key) => examContent[key]); // 是否存在od的柱镜或轴向
      const isHaveOs = osList.some((key) => examContent[key]); // 是否存在os的柱镜或轴向
      const isOdNotEmpty = odList.every((key) => examContent[key]); // od的柱镜和轴向是否都存在
      const isOsNotEmpty = osList.every((key) => examContent[key]); //os的柱镜和轴向是否都存在
      if ((isHaveOd && !isOdNotEmpty) || (isHaveOs && !isOsNotEmpty))return {error: '柱镜轴向不能为空'};
    }
    if (isExit) {
      const result = this.handleResultData(examContent);
      return {...data, examContent: {...examContent, ...result}};
    }
    return data;
  };

  /**
   * 处理一个指标拆分成多个指标项的数据合并
   * @param {*} examContent
   */
  handleResultData = (examContent) => {
    // 检查项的配置
    const {config = {}} = this.props;
    const result = {};
    // 检查项的指标的key
    const {examIndiList = {}} = config; // 获取对应眼别的检查项的指标列表
    const {odList = [], osList = []} = examIndiList;
    const allExamList = [...odList, ...osList];

    Object.entries(examContent).forEach(([key, value], index) => {
      const keyList = key.split('@');
      // 指标的前缀
      const keyPrefix = keyList[0];
      // 指标的后缀
      const keySufiix = keyList[1];
      // 找到该前缀存在的索引
      const examKeyIndex = allExamList.findIndex(
        (item) => item?.option?.key === keyPrefix
      );
      // 找到该前缀存在的单位以及单位放的位置
      const examKeyContent =
        allExamList.find((item) => item?.option?.key === keyPrefix) || {};
      const {option = {}, lastSuffix, account} = examKeyContent;
      const {suffix, suffixStep} = option;
      // console.log('keySufiix', keySufiix, 'suffixStep',suffixStep, 'account', account )
      // examContent[keyPrefix] = '';
      if (!result[keyPrefix]) {
        // 后缀的间隔
        if (keySufiix % suffixStep === 0) {
          result[keyPrefix] = [value, suffix];
        } else {
          result[keyPrefix] = [value];
        }
      } else {
        // 后缀的间隔
        if (keySufiix % suffixStep === 0 && +keySufiix !== account) {
          result[keyPrefix].splice(result[keyPrefix].length, 0, value, suffix);
        } else {
          result[keyPrefix].push(value);
        }
      }
    });
    Object.entries(result).forEach(([key, value]) => {
      // 找到该前缀存在的单位以及单位放的位置
      const examKeyContent =
        allExamList.find((item) => item?.option?.key === key) || {};
      const {lastSuffix} = examKeyContent;
      if (Array.isArray(value) && value.length > 0) {
        // 添加最后的后缀
        // lastSuffix && value.push(lastSuffix);
        let lastValue = value.join(',');
        lastValue = lastValue && lastValue?.replace(/,/g, '');

        if (lastValue[lastValue.length - 1] === '.'){ // 防止数据都为空或者小数点之后的数据为空时，只有一点小数点的问题
          lastValue = lastValue.replace('.', '');
        }
        result[key] = lastValue;

      }
    });
    return result;
  };

  onTabChange = (name, value, unavailableText) => {
    let eyeType = '';

    if (/Od/.test(name)) {
      eyeType = 'OD';
    } else {
      eyeType = 'OS';
    }
    eyeType !== this.state.eyeType && this.setState({eyeType});
  };

  /**
   * 当前输入框的值改变时候
   */
  onInputChange = (name, value) => {
    const {data} = this.state;
    const {examContent = {}} = data;
    const test = {...data, examContent: {...examContent, [name]: value}};

    this.setState({
      data: test,
    });
  };

  /**
   * 下一页
   */
  onKeyNext = () => {
    this.tabRef.current.onNext();
  };

  /**
   * 键盘退格
   */
  onKeyBackspace = () => {
    this.tabRef.current.onBackspace();
  };

  /**
   * 类型切换
   * @param type 眼别类型
   */
  onKeyTypeChange = (type) => {
    // 检查项的配置
    const {config = {}} = this.props;
    // 检查项的指标的key
    const {examIndiList = {}} = config; // 获取对应眼别的检查项的指标列表
    // 找到对应的指标列表
    const examKeyList = examIndiList[`${type.toLowerCase()}List`] || [];
    let name = examKeyList[0]?.option?.key;
    // 指标的list只有一个，且有account属性（即一个指标key，但是在页面上是多个输入框）
    if (examKeyList.length === 1 && examKeyList[0]?.account) {
      name = `${examKeyList[0]?.option?.key}@1`;
    }
    this.tabRef.current.inputAutoFocusByName(name);

    this.setState({eyeType: type});
  };

  /**
   * inputKeyValueChange input的值返回，也可以在onInputChange方法中获取当前改变的值
   * @param value 键盘输入值改变
   */
  onKeyValueChange = (value) => {
    const inputValue = this.tabRef.current.inputKeyValueChange(value);
  };

  /**
   * 输入框失去焦点
   */
  onInputBlur = (name, value, element) => {
    const {config} = this.props;
    const {examIndiList = {}} = config;
    const {odList = [], osList = []} = examIndiList;
    // 找到所有的检查项的列表
    const allExamList = [...odList, ...osList];
    let key = name;
    if (/@/.test(name)) {
      key = name.split('@')[0];
    }
    // 查看当前的检查项是否存在
    const currentExamKey =
      allExamList.find((exam) => exam?.option?.key === key) || {};
    const {option} = currentExamKey;
    const {format} = option;
    // 判断是否需要格式化
    if (format) {
      value = value && utils.format.done(format, value);
    }
    // state控制的则调用此方法
    this.onInputChange(name, value);
  };
  render() {
    const {eyeType, data} = this.state;
    // 检查项的配置
    const {config = {}} = this.props;
    const {examContent = {}} = data;
    // 检查项的指标的key
    const {examIndiList = {}, unavailableKeys = []} = config;
    // 重要1：Tabulation.TabInput 索引不能重复
    // 重要2：Tabulation.TabInput 索引应该是连续的
    // 重要3：Tabulation.TabInput 如果出现要跳过的输入框，它应该有索引并且是连续的，但是它的值是负数

    return (
      <div style={{background: '#fff'}}>
        <Tabulation
          border // input输入框的的边框是否显示
          defaultMaxLength={1} // 整个组件默认的最大输入值，每个输入框可以通过 maxLength 自定义
          // defaultUnavailableText="@/" // 整个组件默认的不可输入的字符
          onTabChange={this.onTabChange} // 焦点切换时回调 name, value, inputElement?
          onInputChange={this.onInputChange} // 输入时候回调 name, value, inputElement?
          onInputBlur={this.onInputBlur} // 输入框失去焦点后回调 name, value, inputElement?
          ref={this.tabRef}
        >
          {['od', 'os'].map((type, index) => {
            // 获取对应眼别的检查项的指标列表
            const examKeyList = examIndiList[`${type}List`] || [];
            const key = `${index}`;
            // 每行的数量
            let rowAccout;
            // 总的数量
            let tabIndexList = [];
            if (examKeyList.length === 1) {
              // 计算每行的数量
              rowAccout = (new Array(examKeyList[0]?.account).fill('') || [])
                .length;
              // 计算总的数量
              tabIndexList = Array.from(new Array(rowAccout * 2).keys());
            } else {
              tabIndexList = Array.from(
                new Array(examKeyList.length * 2).keys()
              );
            }

            return (
              <div style={{display: 'flex', padding: '0 16px'}} key={key}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '28px',
                  }}
                >
                  {type.toLocaleUpperCase()}:
                </div>
                {examKeyList.length === 1 ? (
                  <>
                    {(new Array(examKeyList[0]?.account).fill('') || []).map(
                      (exam, index_) => {
                        const keys = `${index_ + 1}`;
                        const {option = {}, lastSuffix} = examKeyList[0] || {};
                        // 每行的数量
                        const account = examKeyList[0]?.account;
                        // 计算出对应的索引
                        const indexs_ =
                          type === 'od' ? index_ : index_ + account;
                        // 计算出对应的索引
                        const tabIndex = tabIndexList[indexs_];
                        // 前缀字段
                        const {
                          key, // 指标的key
                          suffix, // 后缀
                          suffixStep, // 后缀的间隔指标个数
                          maxLength, // 每个指标最多输入的位数
                          placeholder, // 指标输入框的placeholder
                          width, // 指标的宽度
                        } = option;
                        // 表单的字段
                        const field = `${key}@${index_ + 1}`;
                        return (
                          <div key={keys} style={{display: 'flex'}}>
                            <Tabulation.TabInput
                              tabIndex={tabIndex}
                              name={field}
                              value={examContent[`${key}@${index_ + 1}`]}
                              maxLength={maxLength}
                              placeholder={placeholder}
                              width={width}
                            />
                            {suffix &&
                              index_ + 1 !== account &&
                              (index_ + 1) % suffixStep === 0 && (
                                <span style={{lineHeight: '42px'}}>
                                  {suffix}
                                </span>
                              )}
                            {index_ + 1 === account && (
                              <span style={{lineHeight: '42px'}}>
                                {lastSuffix}
                              </span>
                            )}
                          </div>
                        );
                      }
                    )}
                  </>
                ) : (
                  <>
                    {examKeyList.map((exam, index_) => {
                      const keys = `${index_ + 1}`;
                      const {placeholder, option} = exam; // 每行的数量
                      const {key, suffix, maxLength, width} = option;
                      const account = examKeyList.length;
                      // 计算出对应的索引
                      const indexs_ = type === 'od' ? index_ : index_ + account;
                      // 计算出对应的索引
                      const tabIndex = tabIndexList[indexs_];
                      return (
                        <div key={keys} style={{display: 'flex'}}>
                          <Tabulation.TabInput
                            tabIndex={tabIndex}
                            name={key}
                            value={examContent[key]}
                            maxLength={maxLength}
                            placeholder={placeholder}
                            width={width}
                            className="large_input"
                          />
                          {suffix && index_ + 1 !== account && (
                            <span style={{lineHeight: '42px'}}>{suffix}</span>
                          )}
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            );
          })}
        </Tabulation>
        <div
        // style={{ position: 'fixed', bottom: '0', left: '0', width: '100%' }}
        >
          <Keyboard
            unavailableKeys={unavailableKeys}
            eyeType={eyeType}
            onKeyNext={this.onKeyNext}
            onKeyBackspace={this.onKeyBackspace}
            onKeyTypeChange={this.onKeyTypeChange}
            onKeyValueChange={this.onKeyValueChange}
          />
        </div>
      </div>
    );
  }
}
